import { addDays } from "date-fns";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";
import Team from "@mapmycustomers/shared/types/Team";
import type { PlatformFilterCondition } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import Scope from "@app/types/dashboard/Scope";
import { getLocalTimeZone } from "@app/util/dates";
import { formatDate } from "@app/util/formatters";

const buildFilters = (dateRange: DateRange, scope: Scope, teams: Team[]): PlatformFilterModel => {
  const conditions: PlatformFilterCondition[] = [
    {
      createdAt: {
        $gte: formatDate(dateRange.startDate, "yyyy-MM-dd"),
        $lt: formatDate(addDays(dateRange.endDate, 1), "yyyy-MM-dd"),
        $timezone: getLocalTimeZone(),
      },
    },
    { status: { $in: [EmailStatus.SENT, EmailStatus.ERRORED] } },
  ];

  if (scope.userId) {
    conditions.push({ createdBy: { $in: [scope.userId] } });
  } else if (scope.teamId) {
    const teamMemberIds = teams.find(({ id }) => id === scope.teamId)?.users.map(({ id }) => id);
    if (teamMemberIds?.length) {
      conditions.push({ createdBy: { $in: teamMemberIds } });
    }
  }

  return { $and: conditions };
};

export default buildFilters;
